import React from "react";

/**
 * LoadingSpinner Component - ใช้ CSS-in-JS แบบ inline styles
 *
 * @param {string} text - ข้อความที่จะแสดง (default: "กำลังโหลด...")
 * @param {string} size - ขนาดของ spinner (default: "24px")
 * @param {string} color - สีของ spinner (default: "#FFDB34")
 * @param {string} textColor - สีของข้อความ (default: "#666")
 * @param {string} fontSize - ขนาดฟอนต์ (default: "14px")
 * @param {string} padding - padding ของ container (default: "40px 20px")
 * @param {string} minHeight - ความสูงขั้นต่ำ (default: "auto")
 * @param {boolean} showText - แสดงข้อความหรือไม่ (default: true)
 */
const LoadingSpinner = ({ text = "กำลังโหลด...", size = "24px", color = "#FFDB34", textColor = "#666", fontSize = "14px", padding = "40px 20px", minHeight = "auto", showText = true, className = "" }) => {
  // Inline styles
  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: padding,
    textAlign: "center",
    minHeight: minHeight,
  };

  const spinnerStyle = {
    width: size,
    height: size,
    border: `3px solid #f3f3f3`,
    borderTop: `3px solid ${color}`,
    borderRadius: "50%",
    animation: "loadingSpinner 1s linear infinite",
    marginBottom: showText ? "12px" : "0",
  };

  const textStyle = {
    margin: 0,
    color: textColor,
    fontSize: fontSize,
    fontWeight: 400,
  };

  // CSS keyframes ผ่าน style tag
  const keyframeCSS = `
    @keyframes loadingSpinner {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  return (
    <>
      <style>{keyframeCSS}</style>
      <div style={containerStyle} className={className}>
        <div style={spinnerStyle}></div>
        {showText && <p style={textStyle}>{text}</p>}
      </div>
    </>
  );
};

export default LoadingSpinner;
